// src/components/search/SearchSidebarControls.js
import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import ToggleSwitch from '../common/ToggleSwitch';
import EnhancedSelect from '../common/EnhancedSelect';
import { srsMapping, levelMapping } from '../../utils/mappings';

const SearchSidebarControls = React.forwardRef(({ filters, setFilters }, ref) => {
  const [showTranslation, setTranslationVisibility] = useTranslation();
  const handleFilterChange = (key, value) => setFilters((prev) => ({ ...prev, [key]: value }));

  return (
    <div className="space-y-6" ref={ref}>
      <div>
        <h3 className="text-lg font-semibold text-content-primary">Filters</h3>
        <div className="mt-4 space-y-4">
          <div>
            <label htmlFor="level-filter" className="block text-sm font-medium text-content-secondary pb-1">
              Level
            </label>
            <EnhancedSelect
              id="level-filter"
              value={filters.level}
              onChange={(e) => handleFilterChange('level', e.target.value)}
              options={[{ value: 'all', label: 'All Levels' }, ...Object.entries(levelMapping).map(([value, name]) => ({ value, label: name }))]}
            />
          </div>

          <div>
            <label htmlFor="status-filter" className="block text-sm font-medium text-content-secondary pb-1">
              Status
            </label>
            <EnhancedSelect
              id="status-filter"
              value={filters.learned}
              onChange={(e) => handleFilterChange('learned', e.target.value)}
              options={[
                { value: 'all', label: 'All Status' },
                { value: 'learned', label: 'Learned' },
                { value: 'not-learned', label: 'Not Learned' },
              ]}
            />
          </div>

          <div>
            <label htmlFor="srs-filter" className="block text-sm font-medium text-content-secondary pb-1">
              SRS Stage
            </label>
            <EnhancedSelect
              id="srs-filter"
              value={filters.srsStage}
              onChange={(e) => handleFilterChange('srsStage', e.target.value)}
              options={[{ value: 'all', label: 'All SRS Stages' }, ...Object.entries(srsMapping).map(([value, name]) => ({ value, label: name }))]}
            />
          </div>
        </div>
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <h3 className="text-lg font-semibold text-content-primary">Display</h3>
        <div className="mt-4 space-y-4">
          <div className="flex items-center justify-between">
            <label className="text-sm font-medium text-content-secondary mr-2">Show Translation</label>
            <ToggleSwitch enabled={showTranslation} setEnabled={setTranslationVisibility} />
          </div>
        </div>
      </div>
    </div>
  );
});

SearchSidebarControls.displayName = 'SearchSidebarControls';

export default SearchSidebarControls;
